import { render, staticRenderFns } from "./WholesaleOrders.vue?vue&type=template&id=2ee73654&"
import script from "./WholesaleOrders.vue?vue&type=script&lang=ts&"
export * from "./WholesaleOrders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports